module.exports = __webpack_public_path__ + "static/displacement-a-9793a9326317ea5a7ea43faf81c9074f.jpg";